import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, ListFilter, listSlice, ListType } from '../listHelper';
import axios from 'axios';
import { codeListService } from '@api/services/services';
import { LanguageDto } from '@api/models/settings/LanguageDto';

export type AppTrainingLangListState = ListType<LanguageDto, ListFilter>;

const initialState: AppTrainingLangListState = {
  state: FetchState.None,
  data: undefined,
  query: {},
};

export const appTrainingLangListSlice = listSlice({
  name: 'appTrainingLangList',
  initialState,
});

export const selectAppTrainingLangList = (state: RootState) =>
  state.appTrainingLangList;
export const appTrainingLangListActions = appTrainingLangListSlice.actions;

export const getAppTrainingLangList = () => (dispatch: AppDispatch) => {
  const cancelToken = axios.CancelToken.source().token;

  const storeState = store.getState();
  const data = selectAppTrainingLangList(storeState);

  const handleGetData = () => {
    return codeListService.query();
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: appTrainingLangListActions,
    getData: handleGetData,
  });
};
